import { render } from "./DamageComponent.vue?vue&type=template&id=5f193688"
import script from "./DamageComponent.vue?vue&type=script&lang=js"
export * from "./DamageComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/components/admin/damages/DamageComponent.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "5f193688"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('5f193688', __exports__)) {
    api.reload('5f193688', __exports__)
  }
  
  module.hot.accept("./DamageComponent.vue?vue&type=template&id=5f193688", () => {
    api.rerender('5f193688', render)
  })

}


export default __exports__